module.exports = __webpack_public_path__ + "img/drajzerova-logo-second.6b862706.png";